import React, { FC, ReactNode, useMemo } from 'react';

import { Box, BoxProps, Stack, Typography } from '@mui/material';

export type ResultPanelProps = {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  extra?: ReactNode[];
  rootSx?: BoxProps['sx'];
};

/**
 * TODO
 * [ ] unit testing
 * [ ] docs
 */
const ResultPanel: FC<ResultPanelProps> = (props) => {
  const { icon, title, description, extra = [] } = props;

  const renderIcon = useMemo(() => {
    if (!icon) {
      return null;
    }
    return icon;
  }, [icon]);

  const renderTitle = useMemo(() => {
    if (typeof title === 'string') {
      return (
        <Typography variant="h5" color="#000000DE">
          {title}
        </Typography>
      );
    }
    return title;
  }, [title]);

  const renderDescription = useMemo(() => {
    if (!description) {
      return null;
    }
    if (typeof description === 'string') {
      return (
        <Typography variant="body1" color="#555555" fontFamily="lanna">
          {description}
        </Typography>
      );
    }
    return description;
  }, [description]);

  const hasExtra = extra.length > 0;
  const renderExtra = useMemo(
    () =>
      hasExtra ? (
        <Stack data-testid="extra-listing" direction="row" alignItems="center" gap={2}>
          {extra.map((item) => item)}
        </Stack>
      ) : null,
    [hasExtra, extra],
  );

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={260} py={5} px={3} sx={props?.rootSx}>
      <Stack direction="column" alignItems="center" gap={4}>
        {renderIcon}
        <Stack direction="column" alignItems="center" gap={2}>
          <Stack direction="column" alignItems="center" gap={1}>
            {renderTitle}
            {renderDescription}
          </Stack>
          {renderExtra}
        </Stack>
      </Stack>
    </Box>
  );
};

export default ResultPanel;
